import {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
  useRef,
  useCallback,
  lazy,
} from "react";
import PropTypes from "prop-types";
import { useUserData } from "../userContext";
import { pumpparit_fetchList_for_asiakas } from "src/components/pumppari/PumppariFunctions";
import { addMinutes } from "date-fns";
import {
  buildOsoite,
  firstSecondOfDay,
  getYYYYMMDD,
  lastSecondOfDay,
  parseJSONDate,
} from "src/components/js/statics1";
import { gridSettings_listKeikkas } from "src/pages/Grid/GridSettingsFunctions";
import gridSettingsClass from "src/pages/keikkaGrid/components/gridSettingsClass";
import { useSnackbar } from "../SnackbarContext";
import {
  gridContext_doInsertDayDriverIntoVehicleFromVehicleDayDrivers,
  gridContext_doInsertKeikkasIntoVehicles as gridContext_insertKeikkasIntoVehicles,
  gridContext_doSortVehicles,
  gridContext_doInsertTempPalkit,
  createVehicleKeikkaCache,
} from "./GridContext_Functions";
import { gridContext_doCalcVehicleGridPositions } from "./GridContext_CalcFunctions";
import barColorsClass from "src/pages/Grid/barColorsClass";
import gridPalkkiClass from "src/data/gridPalkki/gridPalkkiClass";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import { betoni_getString } from "src/data/betoni/BetoniFunctions";
import GridVehicleInfoModal from "src/components/grid/GridVehicleInfoModal/GridVehicleInfoModal";
import EditVehicleModal from "src/components/vehicle/EditVehicleModal";

const GridKeikkaEditorModal = lazy(() =>
  import("src/components/grid/GridKeikkaEditor/GridKeikkaEditorModal")
);
const GridPalkkiEditorModal = lazy(() =>
  import("src/components/grid/GridPalkkiEditor/GridPalkkiEditorModal")
);

const visibleKeikkaTilaIds = [-1, 0, 1, 2, 3, 4, 5, 8, 9, 12, 13, 100, -100];

export const GridContext = createContext();

export const GridProvider = ({ children }) => {
  const { auth, user, token, userAsiakas, socket } = useUserData();
  const { openSnackbar } = useSnackbar();

  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({ hasError: false, message: "" });
  const [isDancing, setIsDancing] = useState(false);
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const [fetchDuration, setFetchDuration] = useState(null);
  const [driverOffsetWidth, setDriverOffsetWidth] = useState(50);
  const [vehicleOffsetWidth, setVehicleOffsetWidth] = useState(130);
  const [palkkiTypes, setPalkkiTypes] = useState(null);
  const [hideTooltipBit, setHideTooltipBit] = useState(true);
  const [fullPersonList, setFullPersonList] = useState([]);
  const [fetchCount, setFetchCount] = useState(0);
  const [hideAllTooltipsNonce, setHideAllTooltipsNonce] = useState(0);
  const [keikat_cache, setKeikat_cache] = useState([]);
  const [grid_showDeleted, setGrid_showDeleted] = useState(false);
  const [keikkaAuth, setKeikkaAuth] = useState({});
  const [suodata, setSuodata] = useState("");

  // dragging states
  const [draggingTarget, setDraggingTargetState] = useState({ vehicle: null, action: null });
  const setDraggingTarget = (obj) => {
    if (obj === false || obj === null) {
      // reset draggingTarget if false or null
      if (draggingTarget.vehicle !== null || draggingTarget.action !== null)
        setDraggingTargetState({ vehicle: null, action: null });
      return;
    }
    if (
      obj.vehicle?.vehicleId === draggingTarget.vehicle?.vehicleId &&
      obj.action === draggingTarget.action
    ) {
      // do nothing if values have not changed
      return;
    }
    setDraggingTargetState(obj);
  };

  const [isDragging, setIsDraggingState] = useState({
    any: false,
    vehicle: null,
    driver: null,
    keikka: null,
  });
  const setIsDragging = (obj) => {
    if (obj === false) {
      setIsDraggingState({ any: false, vehicle: null, driver: null, keikka: null });
      return;
    }
    if (
      // check if values have changed before setting them
      obj.vehicle?.vehicleId === isDragging.vehicle?.vehicleId &&
      // obj.driver?.personId === isDragging.driver?.personId &&
      obj.keikka?.keikkaId === isDragging.keikka?.keikkaId
    ) {
      // do nothing
      return;
    }
    setIsDraggingState(obj);
  };

  const [time, setTimeState] = useState({
    isSet: false,
    starttime: null,
    endtime: null,
    yyyymmdd: null,
  });

  const [gridSettings, setGridSettings] = useState(new gridSettingsClass());

  // data set after keikkas are loaded
  const [keikat_state, setKeikat_state] = useState([]);
  const [vehicles_state, setVehicles_state] = useState([]);
  const [drivers_state, setDrivers] = useState([]);
  const [driversLoaded_state, setDriversLoaded] = useState(false);
  const [barColors, setBarColors] = useState({});
  const [gridPalkkiEditorIsOpen, setGridPalkkiEditorIsOpen] = useState(false);
  const [gridPalkki, setGridPalkki] = useState({});
  const [gridKeikkaEditorIsOpen, setGridKeikkaEditorIsOpen] = useState(false);
  const [gridKeikka, setGridKeikka_state] = useState({});
  const [gridVehicleInfoIsOpen, setGridVehicleInfoIsOpen] = useState(false);
  const [selectedGridVehicle, setSelectedGridVehicle] = useState({});
  const [selectedVehicle, setSelectedVehicle] = useState({});

  const [dayDrivers_all_state, setDayDrivers_all] = useState([]); // drivers for all loaded days
  const [dayDrivers_day_state, setDayDrivers_day] = useState([]); // drivers for selected day

  const timeRef = useRef(time);
  const isMountedYYYYMMDD = useRef(time.yyyymmdd);

  const personId = user?.personId;

  const [vehicleKeikkaCache] = useState(() => createVehicleKeikkaCache());

  useEffect(() => {
    console.log("GridContext.jsx 1");
    setFullPersonList([]);
  }, [gridKeikkaEditorIsOpen]);

  useEffect(() => {
    if (!time || !time.isSet) return;
    console.log("GridContext.jsx 2");
    timeRef.current = time;
  }, [time]);

  // start socket listeners
  useEffect(() => {
    if (!socket) return;
    console.log("GridContext.jsx 3");
    socket.on("onSave", (obj) => {
      console.log("socket onSave");
      console.log(obj);
      if (obj.action === "reload") {
        console.log("reload");
        fetchKeikatAndSetStates();
        return;
      }
      let keikkaData = null;
      if (obj.gridKeikka?.keikkaId > 0) keikkaData = obj.gridKeikka;
      else if (obj.gridPalkki?.palkkiId > 0) keikkaData = obj.gridPalkki;
      console.log(keikkaData);
      if (keikkaData) {
        const keikkaIndex = keikat_state.findIndex((k) => k.keikkaId == keikkaData.keikkaId);
        if (keikkaIndex !== -1) {
          keikkaData.timeEnd = parseJSONDate(keikkaData.timeEnd);
          keikkaData.timeStart = parseJSONDate(keikkaData.timeStart);
          const _keikat = [...keikat_state];
          _keikat[keikkaIndex] = keikkaData;
          setKeikat_state(_keikat);
          recalcPositions(_keikat, vehicles_state);
        } else {
          console.log("keikka not found in keikat_state", keikkaData);
          console.log(keikat_state);
        }
      }
    });
    return () => {
      console.log("socket off onSave");
      socket && socket.off("onSave");
    };
  }, [socket]);

  // set time as current day
  // load barColors, load drivers, load vehicles
  // on first load
  useEffect(() => {
    if (time.starttime !== null || time.endtime !== null || !userAsiakas) return;
    console.log("GridContext.jsx 4");
    const _gridSettings = gridSettingsClass.loadFromLocalStorage();
    setGridSettings(_gridSettings);
    const today = gridSettingsClass.loadDateFromLocalStorage();
    const start = firstSecondOfDay(today);
    const end = lastSecondOfDay(today);
    setTime({ starttime: start, endtime: end, yyyymmdd: Number(getYYYYMMDD(today)), isSet: true });
    initBarColors();
  }, [userAsiakas]);

  useEffect(() => {
    // init drivers on userAsiakas change
    if (!userAsiakas) return;
    console.log("GridContext.jsx 5");
    const initDrivers = async () => {
      const drivers = await pumpparit_fetchList_for_asiakas(
        userAsiakas.asiakasId,
        token,
        time.yyyymmdd
      );
      drivers.personList.forEach((d) => {
        d.isTemp = false; // set isTemp = false to all fetched drivers
      });
      // sort drivers.personList by personFirstName then by personLastName
      drivers.personList.sort((a, b) => {
        if (a.personFirstName < b.personFirstName) return -1;
        if (a.personFirstName > b.personFirstName) return 1;
        if (a.personLastName < b.personLastName) return -1;
        if (a.personLastName > b.personLastName) return 1;
        return 0;
      });
      setDrivers(drivers.personList);
      setDriversLoaded(true);
    };
    const initPalkkiTypes = async () => {
      const a = await gridPalkkiClass.getStaticData(userAsiakas.asiakasId);
      setPalkkiTypes(a.gridTypes);
    };
    initDrivers();
    initPalkkiTypes();
  }, [userAsiakas]);

  useEffect(() => {
    if (!driversLoaded_state) return;
    if (time.starttime === null || time.endtime === null || !userAsiakas) return;
    console.log("GridContext.jsx 6");
    isMountedYYYYMMDD.current = time.yyyymmdd;
    gridSettingsClass.saveDateToLocalStorage(time.starttime);
    fetchKeikatAndSetStates();
    return () => {
      socket.emit("leaveAllRooms");
    };
  }, [
    time.starttime,
    time.endtime,
    userAsiakas,
    gridSettings.hideVehicles,
    driversLoaded_state,
    grid_showDeleted,
  ]);

  const fetchKeikatAndSetStates = async () => {
    try {
      socket.emit("leaveAllRooms");

      const _startyyyymmdd = getYYYYMMDD(time.starttime);
      const _endyyyymmdd = getYYYYMMDD(time.endtime);

      setIsLoading(true);
      // set keikat from cache if found
      // do not include keikat where k.grid_palkkiTypeId = 11 and k.timeStart >= time.starttime && k.timeStart < time.endtime
      const _keikat_cache2 = keikat_cache.filter(
        (k) =>
          k.timeStart >= time.starttime &&
          k.timeStart < time.endtime &&
          k.grid_palkkiTypeId !== (grid_showDeleted ? -1 : 11) &&
          k.grid_palkkiTypeId !== (grid_showDeleted ? 3 : 11)
      );

      if (_keikat_cache2.length > 0) {
        // set from cache
        if (isMountedYYYYMMDD.current !== time.yyyymmdd) return; // check if component is still mounted
        setKeikat_state([..._keikat_cache2]);
        recalcPositions(_keikat_cache2, vehicles_state);
      }

      // FETCH DATA
      const _startTimeApi = new Date();
      const _allKeikkas = await gridSettings_listKeikkas(
        personId,
        token,
        time.starttime,
        time.endtime,
        userAsiakas.asiakasId
      );

      if (isMountedYYYYMMDD.current !== time.yyyymmdd) return; // check if component is still mounted
      setFetchDuration(new Date() - _startTimeApi);

      // return error if error
      if (_allKeikkas.success === false) {
        setError({ hasError: true, message: _allKeikkas.errorMessage });
        console.log("gridSettings_listKeikkas failed", _allKeikkas.errorMessage);
        openSnackbar({
          open: true,
          title: "Tilausten lataaminen epäonnistui",
          message:
            _allKeikkas?.length > 0
              ? "Näytetään tilaukset muistista, mikäli niitä on."
              : "Palvelin tai yhteysvirhe!",
          severity: "error",
          autoHideDuration: null,
        });
        return false;
      }

      // set variables from _allKeikkas
      const _newKeikatResult = _allKeikkas.data.keikat;
      const _newKeikkaKuskit = _allKeikkas.data.keikkaKuskit;
      const _newVehicles = _allKeikkas.data.ajoneuvot;
      const _newPalkitResult = _allKeikkas.data.palkit;
      // eslint-disable-next-line no-unused-vars
      const _newPalkkiVisibility = _allKeikkas.data.palkkiVisibility;
      const _newPersonPvm = _allKeikkas.data.personPvm;
      const _newKeikkaBetonit = _allKeikkas.data.keikkaBetonit;
      const _newKeikkaBetoniAttrs = _allKeikkas.data.keikkaBetoniAttrs;
      // insert betoniAttrs into betonit
      for (let i = 0; i < _newKeikkaBetonit.length; i++) {
        const _betoni = _newKeikkaBetonit[i];
        // find rows from attrs where keikkaBetoniId matches
        const _attrs = _newKeikkaBetoniAttrs.filter(
          (a) => a.keikkaBetoniId === _betoni.keikkaBetoniId
        );
        _betoni.attr = _attrs;
        _betoni.betoniString = betoni_getString(_betoni);
      }
      // insert betonit into keikka
      for (let i = 0; i < _newKeikatResult.length; i++) {
        const _keikka = _newKeikatResult[i];
        _keikka.betonit = _newKeikkaBetonit.filter((b) => b.keikkaId === _keikka.keikkaId);
      }

      // replace or insert palkit into keikatlist
      for (let i = 0; i < _newPalkitResult.length; i++) {
        const __palkki = _newPalkitResult[i];
        if (!grid_showDeleted && __palkki.grid_palkkiTypeId === 11) continue;
        const __newKeikka = gridPalkkiClass.getKeikkaFromPalkki(__palkki);
        const __index = _newKeikatResult.findIndex(
          (k) => k.grid_palkki_Id === __newKeikka.palkkiId
        );
        if (__palkki.deletedTime) {
          // remove from array
          if (__index !== -1) _newKeikatResult.splice(__index, 1);
          continue;
        }
        if (__index !== -1) {
          _newKeikatResult[__index] = __newKeikka;
        } else _newKeikatResult.push(__newKeikka);
      }

      // VEHICLES
      // add missing vehicles to _newVehicles if not already there
      for (let i = 0; i < vehicles_state.length; i++) {
        const __vehicle = vehicles_state[i];
        if (!_newVehicles.some((v) => v.vehicleId === __vehicle.vehicleId)) {
          _newVehicles.push(__vehicle);
        }
      }
      // sort vehicles by sortNo
      gridContext_doSortVehicles(gridSettings, _newVehicles);

      // SET DAYDRIVERS_ALL
      // remove from _dayDrivers_all objects that have yyyymmdd between _startyyyymmdd and _endyyyymmdd
      const _dayDrivers_all = dayDrivers_all_state.filter(
        (d) => d.yyyymmdd < _startyyyymmdd || d.yyyymmdd > _endyyyymmdd
      );
      // add _newVehicleDriverDays to _dayDrivers_all
      _dayDrivers_all.push(..._newPersonPvm);
      if (isMountedYYYYMMDD.current !== time.yyyymmdd) return; // check if component is still mounted
      setDayDrivers_all(_dayDrivers_all);
      // SET DAYDRIVERS_DAY
      // create _dayDrivers_day from _dayDrivers_all where yyyymmdd = yyyymmdd
      const _dayDrivers_day = _dayDrivers_all.filter((d) => d.yyyymmdd === time.yyyymmdd);
      gridContext_doInsertDayDriverIntoVehicleFromVehicleDayDrivers(
        _newVehicles,
        _dayDrivers_day,
        driverLookup
      );
      if (isMountedYYYYMMDD.current !== time.yyyymmdd) return; // check if component is still mounted
      setDayDrivers_day(_dayDrivers_day);

      // KEIKAT
      // keep keikat with keikkaTilaId -1,0,1,2,3,4,5,8,9,12,13,100,-100 remove others
      // also remove where grid_palkkiTypeId == 3 or 11
      const _newKeikatFound = _newKeikatResult.filter(
        (k) =>
          visibleKeikkaTilaIds.includes(k.keikkaTilaId) &&
          (grid_showDeleted || k.grid_palkkiTypeId !== 11) &&
          (grid_showDeleted || k.grid_palkkiTypeId !== 3)
      );

      // set keikkaTimes
      if (isMountedYYYYMMDD.current !== time.yyyymmdd) return; // check if component is still mounted
      let { firstKeikka_Time, _lastKeikkaHour, keikkaCount } =
        setFirstLastKeikkaHours(_newKeikatFound);

      // insert kuskit into keikat
      _newKeikatFound.forEach((keikka) => {
        const kuskit = _newKeikkaKuskit.filter((k) => k.keikkaId === keikka.keikkaId);
        keikka.kuskit = kuskit;
        if (keikka.keikkaId > 0) {
          keikka.isKeikka = true;
          keikka.isPalkki = false;
        }
      });

      // insert kuskit into palkit from vehicles
      _newKeikatFound.forEach((palkki) => {
        if (palkki.isPalkki) {
          const palkki_vehicleId = palkki.vehicleId;
          const vehicle = _newVehicles.find((v) => v.vehicleId === palkki_vehicleId);
          const dayDriver = vehicle.dayDriver;
          if (dayDriver) {
            palkki.kuskit = [
              {
                personId: dayDriver.personId,
                personFirstName: dayDriver.personFirstName,
                personLastName: dayDriver.personLastName,
                personPhone: dayDriver.personPhone,
                keikkaId: palkki.keikkaId,
              },
            ];
          } else {
            // console.log("dayDriver not found for vehicle", vehicle);
          }
        }
      });
      // create address
      _newKeikatFound.forEach((_keikka) => {
        _keikka.tyomaaOsoite = buildOsoite(_keikka);
      });
      let newKeikat = [..._newKeikatFound]; // Ensure newKeikat is an array

      // set vehicle.showInGridCalc to false if no keikka for it for the selected day
      // keikka.pumppuAika between _startDate and _endDate
      doHideShowVehicles(_newVehicles, newKeikat);

      // insert keikkas into vehicles keikkaRows
      let newVehicles = gridContext_insertKeikkasIntoVehicles(
        _newVehicles,
        newKeikat,
        gridSettings,
        time,
        vehicleKeikkaCache
      );
      for (let i = 0; i < newVehicles.length; i++) {
        const vehicle = newVehicles[i];
        if (vehicle.showInGridCalc) {
          const kuskit = new Set(
            vehicle.keikkaGroup.flatMap((keikka) => keikka.kuskit?.map((kuski) => kuski?.personId))
          );
          vehicle.driverCount = kuskit.size;
          if (vehicle.driverCount === 0 && vehicle.dayDriver) vehicle.driverCount = 1;
        }
      }
      // add drivers to drivers from keikat if not already there
      // const _d = getUpdatedDriverListFromKeikat(drivers_state, newKeikat, time);
      // setDrivers(_d);

      gridSettings.keikkaFirstHour = firstKeikka_Time?.getHours();
      gridSettings.keikkaLastHour = _lastKeikkaHour;
      gridSettings.keikkaCount = keikkaCount;

      ({ vehicles: newVehicles, keikat: newKeikat } = gridContext_doInsertTempPalkit(
        newVehicles,
        newKeikat,
        userAsiakas,
        time,
        gridSettings
      ));

      if (isMountedYYYYMMDD.current !== time.yyyymmdd) return; // check if component is still mounted
      setKeikat_state(newKeikat);

      // set all vehicles to keikat as keikat.vehicles
      for (let i = 0; i < newKeikat.length; i++)
        newKeikat[i].vehicles = newVehicles.filter((v) => v.vehicleId === newKeikat[i].vehicleId);

      // set vehicle grid positions y
      const _gridHeight =
        gridContext_doCalcVehicleGridPositions(newVehicles, gridSettings) +
          gridSettings.kellonajat_height || 30;
      if (isMountedYYYYMMDD.current !== time.yyyymmdd) return; // check if component is still mounted
      setVehicles_state(newVehicles);

      setGridSettings({
        ...gridSettings,
        grid_height: _gridHeight,
        keikkaFirstHour: firstKeikka_Time?.getHours(),
        keikkaLastHour: _lastKeikkaHour,
        keikkaCount: keikkaCount,
      });

      // send socket connection to rooms
      const keikkaIds = newKeikat.map((k) => k.keikkaId);
      keikkaIds.push(userAsiakas.asiakasId + "_" + time.yyyymmdd);
      socket.emit("joinRooms", keikkaIds);
      // socket.emit("joinRooms", userAsiakas.asiakasId + "_" + time.yyyymmdd);

      if (!isLoaded) setIsLoaded(true);

      // delete keikat in cache that are between time.starttime and time.endtime
      const _keikat_cache = keikat_cache.filter(
        (k) => k.timeStart < time.starttime || k.timeEnd > time.endtime
      );
      // add new keikat to cache
      setKeikat_cache([..._keikat_cache, ...newKeikat]);

      return _newKeikatFound;
    } catch (error) {
      setError({ hasError: true, message: error.message });
      console.log(error);
      return false;
    } finally {
      setIsLoading(false);
      if (!isLoaded) setIsLoaded(true);
      setFetchCount(fetchCount + 1);
    }
  };

  const setTime = (time) => {
    setTimeState({ ...time, yyyymmdd: Number(getYYYYMMDD(time.endtime)) });
  };

  const setGridKeikka = (keikka) => {
    setGridKeikka_state(keikka);
    const keikkaDataAuth = auth.keikkaDataAuth(keikka, user, userAsiakas);
    setKeikkaAuth(keikkaDataAuth);

    // find keikka from keikat_state list and update it
    const keikkaIndex = keikat_state.findIndex((k) => k.keikkaId === keikka.keikkaId);
    if (keikkaIndex !== -1) {
      const _keikat = [...keikat_state];
      _keikat[keikkaIndex] = keikka;
      setKeikat_state(_keikat);
    } else console.log("keikka not found in keikat_state", keikka);
  };
  const doHideShowVehicles = useCallback(
    (vehicles, newKeikat) => {
      if (!userAsiakas) return;
      const _startDate = time.starttime;
      const _endDate = time.endtime;
      vehicles.forEach((vehicle) => {
        vehicle.showInGridCalc = vehicle.showInGrid;
        if (vehicle.showInGrid)
          vehicle.showInGridCalc =
            (vehicle.firstDate === null || vehicle.firstDate < _startDate) &&
            (vehicle.lastDate === null || vehicle.lastDate > _endDate);

        if (gridSettings.hideVehicles || vehicle.asiakasId !== userAsiakas.asiakasId) {
          vehicle.showInGridCalc = newKeikat.some(
            (k) =>
              k.vehicleId === vehicle.vehicleId &&
              k.timeStart >= _startDate &&
              k.timeStart < _endDate
          );
        }
      });
    },
    [time.starttime, time.endtime, gridSettings.hideVehicles, userAsiakas?.asiakasId]
  );

  const setFirstLastKeikkaHours = useCallback(
    (_newKeikatFound) => {
      let firstKeikka_Time = null;
      let lastKeikka_Time = null;
      let cnt = 0;
      for (let i = 0; i < _newKeikatFound.length; i++) {
        const keikka = _newKeikatFound[i];
        keikka.timeStart = parseJSONDate(keikka.pumppuAika);
        if (keikka.timeStart > time.endtime) continue;
        keikka.timeEnd = addMinutes(keikka.timeStart, keikka.pumppuKesto);
        if (keikka.timeEnd < time.starttime || keikka.timeStart > time.endtime) continue;
        if (!firstKeikka_Time || keikka.timeStart < firstKeikka_Time)
          firstKeikka_Time = addMinutes(keikka.timeStart, -keikka.betoniMatkaAika || 0);
        if (!lastKeikka_Time || keikka.timeEnd > lastKeikka_Time) {
          lastKeikka_Time = addMinutes(keikka.timeEnd, keikka.betoniMatkaAika || 0);
        }
        cnt++;
      }
      // set as last minute of day of firstKeikka_Time
      let _lastKeikkaHour = lastKeikka_Time?.getHours();
      if (lastKeikka_Time?.getMinutes() > 0) _lastKeikkaHour += 1; // add one hour if minutes > 0
      const _firstKeikkaHour = firstKeikka_Time?.getHours();

      if (_lastKeikkaHour < 6) _lastKeikkaHour = 24;

      setGridSettings({
        ...gridSettings,
        keikkaFirstHour: _firstKeikkaHour || 6,
        keikkaLastHour: _lastKeikkaHour || 17,
        keikkaCount: cnt,
      });
      return { firstKeikka_Time, _lastKeikkaHour, keikkaCount: cnt };
    },
    [gridSettings, time]
  );

  const recalcPositions = (keikat = null, vehicles = null) => {
    const __keikat = keikat || keikat_state;

    const _keikat = __keikat.filter(
      (k) =>
        visibleKeikkaTilaIds.includes(k.keikkaTilaId) &&
        (grid_showDeleted || k.grid_palkkiTypeId !== 11) &&
        (grid_showDeleted || k.grid_palkkiTypeId !== 3)
    );

    const newVehicles = gridContext_insertKeikkasIntoVehicles(
      vehicles || vehicles_state,
      _keikat,
      gridSettings,
      time,
      vehicleKeikkaCache
    );
    const _gridHeight =
      gridContext_doCalcVehicleGridPositions(newVehicles, gridSettings) +
        gridSettings.kellonajat_height || 30;

    setVehicles_state(newVehicles);

    let firstKeikka_Time = null;
    let lastKeikka_Time = null;

    _keikat.forEach((keikka) => {
      keikka.timeEnd = addMinutes(keikka.timeStart, keikka.pumppuKesto);
      if (keikka.timeEnd < time.starttime || keikka.timeStart > time.endtime) return;
      if (!firstKeikka_Time || keikka.timeStart < firstKeikka_Time)
        firstKeikka_Time = keikka.timeStart;
      if (!lastKeikka_Time || keikka.timeEnd > lastKeikka_Time) lastKeikka_Time = keikka.timeEnd;
    });

    let _lastKeikkaHour = lastKeikka_Time?.getHours();
    if (lastKeikka_Time?.getMinutes() > 0) _lastKeikkaHour += 1; // add one hour if minutes > 0

    setGridSettings({
      ...gridSettings,
      grid_height: _gridHeight,
      keikkaFirstHour: firstKeikka_Time?.getHours(),
      keikkaLastHour: _lastKeikkaHour,
    });
    setKeikat_state(_keikat);
  };
  const initBarColors = async () => {
    const barColors = new barColorsClass();
    await barColors.init(token);
    setBarColors(barColors);
  };

  const reloadKeikat = async () => {
    return await fetchKeikatAndSetStates();
  };

  // fetch daily vehicles
  const dailyVehicles = useMemo(() => {
    if (!vehicles_state || vehicles_state.length === 0) return [];
    return vehicles_state.filter((v) => v.showInGridCalc);
  }, [vehicles_state]);
  // fetch daily keikat
  const dailyKeikat = useMemo(() => {
    if (!keikat_state || keikat_state.length === 0) return [];
    const _list = keikat_state.filter(
      (k) =>
        k.timeStart >= time.starttime &&
        k.timeEnd <= time.endtime &&
        k.vehicleId && // tilauksella on ajoneuvo
        k.isKeikka // keikka, ei palkki
    );
    return _list;
  }, [keikat_state, time.starttime, time.endtime]);

  // fetch daily keikat
  const dailyPalkit = useMemo(() => {
    if (!keikat_state || keikat_state.length === 0) return [];
    return keikat_state.filter(
      (k) => k.timeStart >= time.starttime && k.timeEnd <= time.endtime && k.vehicleId && k.isPalkki
    );
  }, [keikat_state, time.starttime, time.endtime]);

  // Create to lookup table for drivers
  const driverLookup = useMemo(() => {
    if (!drivers_state) return {};
    const lookup = {};
    for (const driver of drivers_state) {
      lookup[driver.personId] = driver;
    }
    return lookup;
  }, [drivers_state]);

  // Create the lookup table for vehicles
  const vehicleLookup = useMemo(() => {
    const lookup = {};
    for (const vehicle of vehicles_state) {
      lookup[vehicle.vehicleId] = vehicle;
    }
    return lookup;
  }, [vehicles_state]);

  const setVehicle = (vehicle) => {
    const index = vehicles_state.findIndex((v) => v.vehicleId === vehicle.vehicleId);
    if (index !== -1) {
      const newVehicles = [...vehicles_state];
      newVehicles[index] = vehicle;
      setVehicles_state(newVehicles);
      gridContext_doCalcVehicleGridPositions(newVehicles, gridSettings);
    } else {
      // add vehicle to vehicles_state
      // check if vehicle is already in vehicles_state
      const existingVehicleIndex = vehicles_state.findIndex(
        (v) => v.vehicleId === vehicle.vehicleId
      );
      if (existingVehicleIndex !== -1) {
        // If the vehicle already exists, update it
        const newVehicles = [...vehicles_state];
        newVehicles[existingVehicleIndex] = vehicle;
        setVehicles_state(newVehicles);
        gridContext_doCalcVehicleGridPositions(newVehicles, gridSettings);
      }
    }
  };

  const setKeikka = (keikka) => {
    const index = keikat_state.findIndex((k) => k.keikkaId === keikka.keikkaId);
    if (index !== -1) {
      const newKeikat = [...keikat_state];
      newKeikat[index] = keikka;
      setKeikat_state(newKeikat);
    } else {
      setKeikat_state([...keikat_state, keikka]);
    }
    recalcPositions();
  };

  const setDayDriver = (vehicleId, driverPersonId, yyyymmdd) => {
    const updateDayDrivers = (dayDrivers, setDayDrivers, vehicleId, driverPersonId, yyyymmdd) => {
      const index = dayDrivers.findIndex(
        (d) => d.vehicleId === vehicleId && d.yyyymmdd === Number(yyyymmdd)
      );

      if (index !== -1) {
        const newDayDrivers = [...dayDrivers];
        newDayDrivers[index].driverPersonId = driverPersonId;
        setDayDrivers(newDayDrivers);
      } else {
        setDayDrivers([...dayDrivers, { vehicleId, driverPersonId, yyyymmdd }]);
      }
    };

    updateDayDrivers(dayDrivers_all_state, setDayDrivers_all, vehicleId, driverPersonId, yyyymmdd);
    updateDayDrivers(dayDrivers_day_state, setDayDrivers_day, vehicleId, driverPersonId, yyyymmdd);

    // Create a new copy of vehicles array
    const newVehicles = [...vehicles_state];
    gridContext_doInsertDayDriverIntoVehicleFromVehicleDayDrivers(
      newVehicles,
      dayDrivers_day_state,
      driverLookup
    );
    setVehicles_state(newVehicles); // Set the new array reference
  };

  const hideAllTooltips = () => {
    if (!hideTooltipBit) setHideTooltipBit(true);
    setHideAllTooltipsNonce(hideAllTooltipsNonce + 1);
  };

  const fullPersonList_addPersons = (persons) => {
    if (!persons || persons.length === 0) return;
    // adds persons not in fullPersonList to fullPersonList
    const newPersons = [...fullPersonList];
    for (let i = 0; i < persons.length; i++) {
      if (!fullPersonList.some((p) => p.personId === persons[i].personId)) {
        newPersons.push(persons[i]);
      }
    }
    setFullPersonList(newPersons);
  };

  const activeDrivers = () => {
    if (!drivers_state) return [];
    const _drivers = drivers_state?.filter(
      (driver) =>
        (driver.startDate === undefined ||
          driver.startDate === null ||
          driver.startDate <= time?.endtime) &&
        (driver.endDate === undefined ||
          driver.endDate === null ||
          driver.endDate >= time?.starttime) &&
        driver.person_deletedTime === null
    );
    return _drivers;
  };

  const handleEditVehicleClose = (a) => {
    setSelectedVehicle(null);
    if (a === true) {
      // save clicked, vehicle has been updated and saved
      // reload vehicles
      reloadKeikat();
      console.log("reload vehicles");
    }
  };

  return (
    <GridContext.Provider
      value={{
        // keikat
        setKeikka, // set keikka to keikat
        keikat: keikat_state, // all keikat
        setKeikat: setKeikat_state,
        dailyKeikat, // keikat for selected timeframe
        dailyPalkit, // palkit for selected timeframe

        // time
        time,
        setTime,

        // reload / init
        reloadKeikat,
        reloadGrid: reloadKeikat,
        reload: reloadKeikat,
        //redoTempPalkit,
        recalcPositions,

        // settings
        gridSettings,
        setGridSettings,
        driverOffsetWidth,
        setDriverOffsetWidth,
        vehicleOffsetWidth,
        setVehicleOffsetWidth,
        isLoaded,
        isLoading,
        setIsLoading,
        error,

        // drivers
        drivers: drivers_state,
        activeDrivers,
        driverLookup,
        dayDrivers_all: dayDrivers_all_state,
        dayDrivers_day: dayDrivers_day_state,
        setDayDriver,
        // vehicles
        vehicles: vehicles_state,
        setVehicles: setVehicles_state,
        setVehicle,
        vehicleLookup, // lookup table for vehicles, find vehicle fast
        dailyVehicles, // vehicles for selected timeframe
        // dancing
        isDancing,
        setIsDancing,
        // GRID colors
        barColors,
        reloadBarColors: initBarColors,
        // GRID palkit
        palkkiTypes,
        setPalkkiTypes,
        gridPalkkiEditorIsOpen,
        setGridPalkkiEditorIsOpen,
        gridPalkki,
        setGridPalkki,
        gridKeikkaEditorIsOpen,
        setGridKeikkaEditorIsOpen,
        gridKeikka,
        setGridKeikka,
        drawerIsOpen,
        setDrawerIsOpen,
        // dragging
        isDragging,
        setIsDragging,
        draggingTarget,
        setDraggingTarget,
        // others
        fetchCount,
        fetchDuration,
        hideTooltipBit,
        hideAllTooltips,
        hideAllTooltipsNonce,
        suodata,
        setSuodata,
        // fullPersonList
        fullPersonList,
        fullPersonList_addPersons,
        // settings
        grid_showDeleted,
        setGrid_showDeleted,
        keikkaAuth,
        gridVehicleInfoIsOpen,
        setGridVehicleInfoIsOpen,
        selectedGridVehicle,
        setSelectedGridVehicle,

        // edit vehicle is open when selectedVehicle is not null
        selectedVehicle,
        setSelectedVehicle,
      }}>
      {children}
      <LazyLoader>
        <GridKeikkaEditorModal />
        <GridPalkkiEditorModal />
        <GridVehicleInfoModal />
        <EditVehicleModal
          vehicle={selectedVehicle}
          open={selectedVehicle?.vehicleId > 0}
          onClose={handleEditVehicleClose}
        />
      </LazyLoader>
    </GridContext.Provider>
  );
};

export const useGridData = () => useContext(GridContext);

GridProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
// function getUpdatedDriverListFromKeikat(drivers_state, newKeikat, time) {
//   {
//     const _drivers = drivers_state.filter((d) => d.isTemp !== true);
//     let didAdd = false;
//     const dailyKeikat = newKeikat.filter(
//       (k) => k.timeStart >= time.starttime && k.timeEnd <= time.endtime && k.vehicleId
//     );
//     for (let i = 0; i < dailyKeikat.length; i++) {
//       for (let j = 0; j < dailyKeikat[i].kuskit.length; j++) {
//         const _kuski = dailyKeikat[i].kuskit[j];
//         // check if _kuski is in drivers
//         if (!_drivers.some((d) => d.personId === _kuski.personId)) {
//           didAdd = true;
//           // add _kuski to drivers
//           _drivers.push({
//             personId: _kuski.personId,
//             personFirstName: _kuski.personFirstName,
//             personLastName: _kuski.personLastName,
//             personPhone: _kuski.personPhone,
//             firstDate: null,
//             lastDate: null,
//             person_deletedTime: null,
//             isTemp: true,
//             hide: false,
//           });
//         }
//       }
//     }
//     if (didAdd || drivers_state.length !== _drivers.length) {
//       // sort drivers.personList by personFirstName then by personLastName
//       _drivers.sort((a, b) => {
//         if (a.personFirstName < b.personFirstName) return -1;
//         if (a.personFirstName > b.personFirstName) return 1;
//         if (a.personLastName < b.personLastName) return -1;
//         if (a.personLastName > b.personLastName) return 1;
//         return 0;
//       });
//       return _drivers;
//     }
//   }
// }
